import { CreditCardDtoCollection } from "@NA/Services/SavedCreditCardsService";
import ADIColors from "@NA/Utils/ADIColors";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

export interface ADICardView {
    cardView?: InjectableCss;
}

export const adiCardView: ADICardView = {
    cardView: {
        css: css`
            display: flex;
            flex-direction: column;
            font-size: 14px;
            > .expired {
                color: ${ADIColors.danger};
            }
        `,
    }
};

const styles = adiCardView;

interface OwnProps {
    item: CreditCardDtoCollection | null;
    filterCardType: (key: string) => string;
    newCard: boolean;
}

const ADICreditCardView = ({ item, filterCardType,newCard }: OwnProps) => {
    if (!item) {
        return null;
    }
    const [isExpired, setIsExpired] = useState(false);
    let expiryYear = "";
    let cardNumber = "";
    // Code to show expiry year in diff formatting for New card and Editing card ----- P21 Change
    if(newCard == true)
    {
     expiryYear = item.expiryYear.toString();
     cardNumber = item.cardNumber.toString();
    }
    else
    {
    if(item.expiryYear.toString().length > 2)
    expiryYear = item.expiryYear.toString().substring(2, 4);
    else
    expiryYear = item.expiryYear.toString();
    if(item.cardNumber.toString().length > 4)
    {
    //cardNumber = item.cardNumber.toString().substring(12,16);
    // Changes as per US Spire view section
    const cardNumberlen = item.cardNumber.toString().length ;
    const lastIndex = item.cardNumber.toString().lastIndexOf("X");
    cardNumber = item.cardNumber.toString().substring(lastIndex + 1 , cardNumberlen + 1);
    }
    else
    cardNumber = item.cardNumber.toString();

    }

    const checkExpirationDate = (month: any, year: any) => {
        var d = new Date();
        month = parseInt(month);
        year = year.length == 2 ? parseInt(d.getFullYear().toString().substring(0, 2) + year) : year;
        if (year == d.getFullYear() && month < (d.getMonth() + 1)) {
            return true;
        }

        if (year < d.getFullYear()) {
            return true;
        }

        return false;
    }
    
    useEffect(() => {
        setIsExpired(checkExpirationDate(item.expiryMonth, item.expiryYear));
    }, [item]);
    return (
        <Typography {...styles.cardView}>
            <span> {filterCardType(item.cardType)} </span>
            <span> ****{cardNumber} </span>
            <span >
                {translate("Expiration Date")} {item.expiryMonth}/{expiryYear}  {isExpired && <span style={{color: `${ADIColors.danger}`}}>{translate("( Expired )")}</span>}
            </span>
           
        </Typography>
    );
};

export default ADICreditCardView;
